import { render, staticRenderFns } from "./EditOfficetraxModal.vue?vue&type=template&id=4cab3d92&"
import script from "./EditOfficetraxModal.vue?vue&type=script&lang=js&"
export * from "./EditOfficetraxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports